export default function baseUrl() {
    // Check if running in development
    const isDevelopment = process.env.NODE_ENV === 'development';
    
    // Use environment variable if set, otherwise default based on hostname
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
    }
    
    // Fallback logic
    const isLocal = window.location.hostname === 'localhost';
    return isLocal ? 'http://localhost:5000' : '/api';
}
